import React from "react";
import { DateRangePicker } from "rsuite";
import * as dateFns from "date-fns";
import "./DaterangePicker.scss";

function DaterangePicker(props: any) {
  const DateRangeDefaultData: any = [
    {
      label: "Last 7 Days",
      value: [
        dateFns.startOfDay(dateFns.subDays(new Date(), 6)),
        dateFns.endOfDay(new Date()),
      ],
    },
    {
      label: "Last 30 Days",
      value: [
        dateFns.startOfDay(dateFns.subDays(new Date(), 29)),
        dateFns.endOfDay(new Date()),
      ],
    },
    {
      label: "Last 90 Days",
      value: [
        dateFns.startOfDay(dateFns.subDays(new Date(), 89)),
        dateFns.endOfDay(new Date()),
      ],
    },
  ];
  const { allowedRange, afterToday } = DateRangePicker;
  const { onChange, dateRange, allowedDateRange } = props;

  return (
    <div className="daterangepicker-wrapper px-2 pt-2">
      <DateRangePicker
        onChange={(value) => {
          onChange && onChange(value);
        }}
        cleanable={true}
        ranges={DateRangeDefaultData}
        value={dateRange}
        placeholder="From Date – To Date"
        character=" – "
        showOneCalendar
        format="dd-MM-yyyy"
        editable={false}
        shouldDisableDate={
          allowedRange &&
          allowedRange(
            (allowedDateRange &&
              allowedDateRange.fromDate &&
              new Date(allowedDateRange.fromDate)) ||
              dateFns.startOfDay(dateFns.subDays(new Date(), 90)),
            (allowedDateRange &&
              allowedDateRange.toDate &&
              new Date(allowedDateRange.toDate)) ||
              dateFns.startOfDay(new Date())
          )
        }
        limitEndYear={new Date().getUTCFullYear()}
      />
    </div>
  );
}

export default DaterangePicker;
